module.exports = __webpack_public_path__ + "img/Cook Islands.b574ecee.svg";